import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): boolean {
    const isLoggedIn = !!localStorage.getItem('tokenAuth');
    if (isLoggedIn) {
      this.router.navigate(['dashboard']);
    }

    return !isLoggedIn;
  }
}
